<template>
  <div>
    <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      
      <!--名称-->
      <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="formData.title" autocomplete="off" placeholder="请输入" class="max-w460"></el-input>
      </el-form-item>
      <!--名称-->
      <el-form-item label="说明" prop="intro" :label-width="formLabelWidth">
        <el-input v-model="formData.intro" autocomplete="off" type="textarea" :rows="10" placeholder="请输入" class="max-w460"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">不开放</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import FormApi from '@/api/study/form.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        title: '',
        intro: '',
        status: 1,
      },
      /*验证规则*/
      formRules: {
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['open_edit', 'selectModel'],
  created() {
    this.dialogVisible = this.open_edit;
    this.formData = this.selectModel;
  },
  methods: {
    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          FormApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
  }
};
</script>

<style>
.custom td {
  padding: 5px 0;
}
.custom input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/study/custom/form/part/Edit.vue